import { Pipe, PipeTransform } from '@angular/core';
import { DayOfWeek } from '@services';

@Pipe({
    name: 'dayOfWeek',
    standalone: true,
})
export class DayOfWeekPipe implements PipeTransform {
    transform(value: DayOfWeek | number | string | undefined | null): string {
        if (value === null || value === undefined) return '';

        const name = DayOfWeek[value as DayOfWeek];
        return typeof name === 'string' ? name.substring(0, 3) : '';
    }
}
